module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.company) ? _c('li', {
    staticClass: "mktp-menu dropdown",
    class: {
      'active': _vm.routeName.startsWith('mktp_')
    }
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": {
        name: 'mktp_home'
      },
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n    Pedidos"), (_vm.mktp_orders > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.mktp_orders))]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1abaf8da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MktpMenu.vue
// module id = 785
// module chunks = 2